var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.673 15.26l-11-10A1 1 0 0018 6v4.302c-2.816.003-9.449.635-13.782 6.075-2.173 2.728-2.909 7.528-3.186 9.335l-.021.135a1 1 0 001.745.806c1.608-1.861 4.397-4.361 8.55-5.702a18.726 18.726 0 016.693-.884v4.932a1.002 1.002 0 001.634.774l11-9a.997.997 0 00.039-1.514z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.2871fb93791281625254574f0a363783.svg";
export { ForwardRef as ReactComponent };